import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../contexts/SubscriptionContext';

const VARIANT_CLASSES = {
  GRACE: 'border-amber-200 bg-amber-50 text-amber-800',
  READ_ONLY: 'border-red-200 bg-red-50 text-red-700',
  DORMANT: 'border-red-200 bg-red-50 text-red-700',
};

function SubscriptionBanner() {
  const { t } = useTranslation('common');
  const { status } = useSubscription();

  if (!status || status.state === 'ACTIVE') {
    return null;
  }

  const message =
    status.state === 'GRACE'
      ? t('subscriptionBanner.grace', { days: status.daysRemaining ?? 0 })
      : status.state === 'READ_ONLY'
      ? t('subscriptionBanner.readOnly')
      : t('subscriptionBanner.dormant');

  return (
    <div
      className={`mx-6 mt-6 rounded-xl border p-4 flex items-center justify-between gap-4 flex-wrap ${VARIANT_CLASSES[status.state]}`}
    >
      <p className="text-sm">{message}</p>
      <button
        type="button"
        onClick={() => window.alert(t('subscriptionBanner.reactivateComingSoon'))}
        className="inline-flex items-center rounded-lg bg-gradient-to-r from-orange-500 to-amber-600 px-4 py-2 text-sm font-semibold text-white shadow-md shadow-orange-200 transition hover:from-orange-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2"
      >
        {t('subscriptionBanner.reactivate')}
      </button>
    </div>
  );
}

export default SubscriptionBanner;
